<script>
  import {onMount, createEventDispatcher} from 'svelte'
  import Cookies from 'js-cookie'

  let loggedIn = false
  let failed = false
  let pwd = Cookies.get('pwd') ?? ''
  let sending = false
  $: submitText = sending ? 'Please wait...' : 'Submit'

  const dispatch = createEventDispatcher()

  onMount(() => {
    if(pwd) {
      doLogin()
    }
  })

  async function doLogin () {
    sending = true
    const res = await fetch("/api/login", {method: 'POST', body: JSON.stringify({pwd})});
    const data = await res.json();
    loggedIn = data.success;
    if(loggedIn) Cookies.set('pwd', pwd, {expires: 365})
    failed = data.success === false
    dispatch('loggedIn', data.success)
    sending = false
  }
</script>

{#if !loggedIn}
  <iframe title="rememberer" src="blank.html" name="rememberer" style="display: none"></iframe>
  <section>
    <form on:submit={doLogin} id="login" class:failed="{failed === true}" target="rememberer">
      <label for="pwd">Password</label>
      <div class="row">
        <input id="pwd" type="password" autocomplete="new-password" name="login" bind:value={pwd} />
        <button type="submit" disabled={sending}>{submitText}</button>
      </div>
    </form>
  </section>
{/if}


<style>
  .row {
    display: flex;
    flex-direction: column;
		width: 100%;
	}
	input {
		flex: 1;
	}
  label {
    display: block;
  }
	button {
    margin-top: 1.25rem !important;
		margin-left: 0 !important;
	}
  form.failed #pwd,
  form.failed #pwd:focus  {
    border-bottom-color: var(--red) !important;
  }
  @media (min-width: 480px) {
    .row {
      flex-direction: row;
    }
    button {
      margin-top: 0 !important;
      margin-left: 0.625rem !important;
    }
    input {
      max-width: 300px;
    }
  }
</style>